import React, { createContext, useEffect, useState } from "react";
import ReactGA from "react-ga";

import { getSavedData, saveLocalData } from "./helperFunctions";

const MainContext = createContext();

const MainContextProvider = ({ children }) => {
  const [userData, setUserData] = useState({});
  const [cartData, setCartData] = useState([]);
  const [currentPath, setCurrentPath] = useState("");
  const [slots, setSlots] = useState([]);

  useEffect(() => {
    ReactGA.initialize("UA-212428061-1")
    if (getSavedData("userData")) setUserData(getSavedData("userData"));
    if (getSavedData("cartData")) setCartData(getSavedData("cartData"));
  }, []);

  useEffect(() => saveLocalData("userData", userData), [userData]);
  useEffect(() => saveLocalData("cartData", cartData), [cartData]);
  useEffect(() => ReactGA.pageview("/" + currentPath), [currentPath])

  return (
    <MainContext.Provider
      value={{
        userData: userData,
        setUserData: setUserData,
        cartData: cartData,
        setCartData: setCartData,
        setCurrentPath: setCurrentPath,
        slots: slots,
        setSlots: setSlots,
      }}
    >
      {children}
    </MainContext.Provider>
  );
};

export { MainContext, MainContextProvider };
